<script setup lang="ts">
import { useId } from 'vue'

export interface SancareCheckboxProps {
  label?: string | null
  disabled?: boolean
}

withDefaults(defineProps<SancareCheckboxProps>(), {
  label: null,
  disabled: false,
})

const model = defineModel<boolean>({ default: false })
const id = useId()
</script>

<template>
  <div class="form-check">
    <input
      :id="id"
      v-model="model"
      type="checkbox"
      class="form-check-input"
      :class="{cp: !disabled}"
      :disabled="disabled"
    >
    <label
      v-if="label"
      :for="id"
      class="form-check-label"
      :class="{cp: !disabled}"
    >{{ label }}</label>
  </div>
</template>
